import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { apiUrl } from "../../consts/consts";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PasswordReset() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [userEmailError, setUserEmailError] = useState("");
  const [invalidTokenError, setInvalidTokenError] = useState(false);
  const [validToken, setValidToken] = useState(false);
  const [userPasswordError, setUserPasswordError] = useState("");

  const notifyWarning = (message) =>
    toast.error(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      className: "toast-message",
    });

  const regExpEmail = /^[^\s@]+@[^\s@]+$/;

  const params = useParams();
  const token = params.token;

  async function checkToken() {
    try {
      const response = await axios.get(`${apiUrl}/password/reset/${token}`);
      if (response.data.valid) {
        setValidToken(true);
        setInvalidTokenError(false);
      }
    } catch (error) {
      console.log(error);
      setInvalidTokenError(true);
    }
  }

  useEffect(() => {
    if (token) {
      checkToken();
    }
  }, []);

  const inputHandler = (e) => {
    setUserEmail(e.target.value);
  };

  const pass1Handler = (e) => {
    setPass1(e.target.value);
  };

  const pass2Handler = (e) => {
    setPass2(e.target.value);
  };

  async function handleSubmit(event) {
    event.preventDefault();
    const errorInEmail = userEmail.length === 0 || !regExpEmail.test(userEmail);
    setUserEmailError(errorInEmail);

    if (!errorInEmail) {
      try {
        await axios.post(`${apiUrl}/password/reset`, {
          email: userEmail.trim(),
        });
        navigate("/login");
      } catch (e) {
        console.log(e.message);
      }
    }
  }

  async function handlePasswordSubmit() {
    if (pass1 === pass2) {
      await axios.post(`${apiUrl}/password/reset/${token}`, {
        password: pass1,
        confirmPassword: pass2,
      });
      navigate("/login");
    } else {
      setUserEmailError("Passwords don't match");
      notifyWarning(userPasswordError);
    }
  }

  return (
    <div className="wrapper">
      <div className="card">
        <div id="logo"></div>
        {!validToken ? (
          <div className="login-form">
            {invalidTokenError && (
              <p>Your token has expired, please Request a new token</p>
            )}
            <br />
            <br />
            <label htmlFor="">Email</label>
            <input
              onChange={inputHandler}
              value={userEmail}
              placeholder="Type your email"
              type="email"
            />{" "}
            <br />
            <br />
            <button
              className="action-button"
              onClick={handleSubmit}
              type="submit"
            >
              Reset Password
            </button>
            <br />
            <p>
              <a onClick={() => navigate("/login")}>Return to Login</a>
            </p>
          </div>
        ) : (
          <div className="login-form">
            <br />
            <label htmlFor="">Password</label>
            <input onChange={pass1Handler} value={pass1} type="password" />
            <br />
            <label htmlFor="">Repeat Password</label>
            <input onChange={pass2Handler} value={pass2} type="password" />
            <br />
            <button
              className="action-button"
              onClick={handlePasswordSubmit}
              type="submit"
            >
              Reset Password
            </button>
            <br />
          </div>
        )}
      </div>
    </div>
  );
}

export default PasswordReset;
